import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/esnext.iterator.some.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { Core } from "@faire/design-tokens";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { Chevron } from "@faire/web--source/slate/icons/foundation/Chevron";
import { FormInputLabel } from "@faire/web--source/slate/Input";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import * as React from "react";
import { useTheme } from "styled-components";
import { MobileChevronWrapper, MobileInnerWrapper, MobileSelectWrapper, StyledSelect } from "../styles";
export var MobileDropdown = function MobileDropdown(_ref) {
  var _theme$input$label, _theme$input$label$co, _theme$input$label2, _theme$input$helper;
  var borderless = _ref.borderless,
    className = _ref.className,
    dataTestId = _ref.dataTestId,
    disabled = _ref.disabled,
    errorMessage = _ref.errorMessage,
    options = _ref.options,
    helper = _ref.helper,
    id = _ref.id,
    label = _ref.label,
    onOpen = _ref.onOpen,
    onSelect = _ref.onSelect,
    placeholder = _ref.placeholder,
    showErrorMessage = _ref.showErrorMessage,
    showErrorState = _ref.showErrorState,
    value = _ref.value;
  var theme = useTheme();
  var isValueInOptions = options.some(function (option) {
    return option.value === value;
  });
  var validValue = isValueInOptions ? value : "";
  var handleSelectClick = React.useCallback(function (e) {
    onOpen === null || onOpen === void 0 ? void 0 : onOpen();
    e.preventDefault();
    e.stopPropagation();
  }, [onOpen]);
  return /*#__PURE__*/React.createElement(MobileSelectWrapper, {
    className: className
  }, isNotUndefined(label) ? /*#__PURE__*/React.createElement(FormInputLabel, {
    $typography: _objectSpread(_objectSpread({}, (_theme$input$label = theme === null || theme === void 0 ? void 0 : theme.input.label) !== null && _theme$input$label !== void 0 ? _theme$input$label : {}), {}, {
      color: showErrorState ? "error" : (_theme$input$label$co = theme === null || theme === void 0 ? void 0 : (_theme$input$label2 = theme.input.label) === null || _theme$input$label2 === void 0 ? void 0 : _theme$input$label2.color) !== null && _theme$input$label$co !== void 0 ? _theme$input$label$co : Core.text.default
    })
  }, label) : null, /*#__PURE__*/React.createElement(MobileInnerWrapper, {
    $borderless: borderless,
    $showErrorState: showErrorState,
    $disabled: disabled
  }, /*#__PURE__*/React.createElement(MobileChevronWrapper, null, /*#__PURE__*/React.createElement(Chevron, {
    direction: "down",
    color: disabled ? Core.icon.disabled : Core.icon.default,
    width: "8",
    height: "8",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement(StyledSelect, {
    id: id,
    "data-test-id": dataTestId
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore used for tests, even though it's not a valid prop on select in some React versions.
    ,
    placeholder: placeholder,
    disabled: disabled,
    onClick: handleSelectClick,
    onChange: function onChange(e) {
      return onSelect(e.target.value);
    },
    value: validValue || ""
  }, placeholder ? /*#__PURE__*/React.createElement("option", {
    value: "",
    disabled: true
  }, placeholder) : null, options.map(function (option) {
    return /*#__PURE__*/React.createElement("option", {
      "data-test-id": "dropdownItem_".concat(option.value),
      key: option.value,
      value: option.value,
      disabled: option.disabled
    }, option.label);
  }))), helper && !showErrorMessage ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    size: 4
  }), /*#__PURE__*/React.createElement(Typography, _objectSpread({
    color: Core.text.subdued
  }, (_theme$input$helper = theme === null || theme === void 0 ? void 0 : theme.input.helper) !== null && _theme$input$helper !== void 0 ? _theme$input$helper : {}), helper)) : null, showErrorMessage ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    size: 4
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "labelSansRegular",
    color: Core.text.critical
  }, errorMessage)) : null);
};